export default {
    state: {
        opened: false,
        redirectURL: null,
        hasUnsavedChanges: false,
    },
    getters: {
        isOpen: state => payload => state.opened,
        getRedirect: state => payload => state.redirectURL,
        hasUnsavedChanges: state => payload => state.hasUnsavedChanges,
    },
    mutations: {
        toggleOpen: (state, payload) => {
            state.opened = !state.opened;
        },
        setRedirect: (state, redirectURL) => {
            state.redirectURL = redirectURL;
        },
        setHasUnsavedChanges: (state, bool) => {
            state.hasUnsavedChanges = bool;
        },
    },
};
